import { h } from "preact";
export { h };
